var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"prizes__carousel"},[_c('div',{staticClass:"prizes-carousel generic-carousel"},_vm._l((_vm.carouselVisitorPrizes),function(prize){return _c('div',{key:prize.type,staticClass:"item",staticStyle:{"cursor":"pointer"}},[_c('img',{attrs:{"src":prize.imgUrl,"alt":""}})])}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c23ab38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/visitor/VisitorCarousel.vue
// module id = null
// module chunks = 